import React from 'react';

export const GoogleSpreadsheetIcon = () => (
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="mask0_271_181645" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask0_271_181645)">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L18.7188 7.18182L16.375 4Z"
				fill="#0F9D58"
			/>
		</g>
		<mask id="mask1_271_181645" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask1_271_181645)">
			<path
				d="M10.75 13.7734V20.3643H18.25V13.7734H10.75ZM14.0313 19.4553H11.6875V18.3189H14.0313V19.4553ZM14.0313 17.6371H11.6875V16.5007H14.0313V17.6371ZM14.0313 15.8189H11.6875V14.6825H14.0313V15.8189ZM17.3125 19.4553H14.9688V18.3189H17.3125V19.4553ZM17.3125 17.6371H14.9688V16.5007H17.3125V17.6371ZM17.3125 15.8189H14.9688V14.6825H17.3125V15.8189Z"
				fill="#F1F1F1"
			/>
		</g>
		<mask id="mask2_271_181645" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask2_271_181645)">
			<path
				d="M16.7866 9.05518L22.0003 14.1097V9.45404L16.7866 9.05518Z"
				fill="url(#paint0_linear_271_181645)"
			/>
		</g>
		<mask id="mask3_271_181645" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask3_271_181645)">
			<path
				d="M16.375 4V8.09091C16.375 8.84432 17.0043 9.45454 17.7813 9.45454H22L16.375 4Z"
				fill="#87CEAC"
			/>
		</g>
		<mask id="mask4_271_181645" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask4_271_181645)">
			<path
				d="M8.40625 4C7.63281 4 7 4.61364 7 5.36364V5.47727C7 4.72727 7.63281 4.11364 8.40625 4.11364H16.375V4H8.40625Z"
				fill="white"
				fillOpacity="0.2"
			/>
		</g>
		<mask id="mask5_271_181645" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask5_271_181645)">
			<path
				d="M20.5937 23.8866H8.40625C7.63281 23.8866 7 23.2729 7 22.5229V22.6366C7 23.3866 7.63281 24.0002 8.40625 24.0002H20.5937C21.3672 24.0002 22 23.3866 22 22.6366V22.5229C22 23.2729 21.3672 23.8866 20.5937 23.8866Z"
				fill="#263238"
				fillOpacity="0.2"
			/>
		</g>
		<mask id="mask6_271_181645" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask6_271_181645)">
			<path
				d="M17.7812 9.45494C17.0043 9.45494 16.375 8.84472 16.375 8.09131V8.20495C16.375 8.95835 17.0043 9.56858 17.7812 9.56858H22V9.45494H17.7812Z"
				fill="#263238"
				fillOpacity="0.1"
			/>
		</g>
		<path
			d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
			fill="url(#paint1_radial_271_181645)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_271_181645"
				x1="277.498"
				y1="52.454"
				x2="277.498"
				y2="514.58"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#263238" stopOpacity="0.2" />
				<stop offset="1" stopColor="#263238" stopOpacity="0.02" />
			</linearGradient>
			<radialGradient
				id="paint1_radial_271_181645"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(54.5207 43.5288) scale(2418.73 2345.43)"
			>
				<stop stopColor="white" stopOpacity="0.1" />
				<stop offset="1" stopColor="white" stopOpacity="0" />
			</radialGradient>
		</defs>
	</svg>
);
